<template  >
<div class="ui pointing menu" >
  <router-link v-for="item in menu" :key="item.moduleId" :to="item.redirectingLink"><div :class ="item.class" 
  @click="setClass(item.redirectingLink)" >{{ item.moduleName }}</div>
  </router-link> 
  <div class="right menu">
    <div class="item" >
       Logged in as : {{ this.displayName }}
    </div>
    <div class="item">
       <nav  > <router-link to="/" ><a>Log Out</a></router-link> </nav>
    </div>
  </div>
</div>
</template>

<script>

import axios from "axios";
import Vue from 'vue'

export default {
    data () {
      return {
      menu : [],
      displayName : ''
      }
    },
   methods: {
   setClass(name){
      localStorage.setItem('menuCliked',name );
      for (var i = 0; i < this.menu.length; i++) {
      if (this.menu[i].redirectingLink == localStorage.getItem('menuCliked')) {
      this.menu[i].class = "active item";
      }else{
      this.menu[i].class = "item";
      }
    }
  },
  bindMenuFromCache(){
    let menuOutput = JSON.parse(localStorage.getItem("menu"));
    this.menu = menuOutput.data;
    if(localStorage.getItem('menuCliked')==null){
       this.setClass(this.menu[0].redirectingLink);
    }
    this.displayName = this.menu[0].displayName ;
    if(localStorage.getItem('menuCliked') !=null && localStorage.getItem('menuCliked') != ""){
      this.setClass(localStorage.getItem('menuCliked'));
    }
   }
 },
  created(){
    this.bindMenuFromCache(); 
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue